import React from 'react';
import { Pressable, Text, View } from 'react-native';
import { StyleSheet } from 'react-native-unistyles';

export default function SegmentedTabs({ tabs, value, onChange, testIDPrefix = 'segmented-tab', disabled = false }) {
    return (
        <View style={styles.tabs(disabled)} accessibilityRole="tablist">
            {tabs.map((tab) => {
                const selected = value === tab.key;
                return (
                    <Pressable
                        key={tab.key}
                        testID={`${testIDPrefix}-${tab.key}`}
                        accessibilityRole="tab"
                        accessibilityState={{ selected, disabled }}
                        disabled={disabled}
                        onPress={() => onChange(tab.key)}
                        style={styles.tab(selected, disabled)}
                    >
                        <Text style={styles.label(selected)}>{tab.label}</Text>
                    </Pressable>
                );
            })}
        </View>
    );
}

const styles = StyleSheet.create(({ colors, fonts, spacing, typography, shadows, roundness }) => ({
    tabs: (disabled) => ({
        flexDirection: 'row',
        padding: spacing.xs,
        gap: spacing.xs,
        borderRadius: roundness.md,
        backgroundColor: colors.surfaceVariant,
        opacity: disabled ? 0.6 : 1,
    }),
    tab: (selected, disabled) => ({
        flex: 1,
        minWidth: 0,
        paddingVertical: spacing.sm,
        alignItems: 'center',
        borderRadius: roundness.sm,
        backgroundColor: selected ? colors.surface : 'transparent',
        boxShadow: selected ? shadows.card : 'none',
        _web: { cursor: disabled ? 'not-allowed' : 'pointer' },
    }),
    label: (selected) => ({
        fontSize: typography.caption,
        fontFamily: selected ? fonts.bold : fonts.heading,
        color: selected ? colors.text : colors.textSecondary,
    }),
}));
